<template>
    <div class="sms-whitelist-page">
        <div class="global-header-wrap">
            <div class="user-header-left">
                <div class="left-part">
                    <span>区号</span>
                    <div class="listSearch">
                        <el-input v-model="areaCode" clearable @keyup.enter.native="search"
                            @clear="clearSearch('areaCode')" placeholder="请输入区号（如：+86）">
                        </el-input>
                    </div>
                </div>
                <div class="left-part">
                    <span>手机号</span>
                    <div class="listSearch">
                        <el-input v-model="phone" clearable @keyup.enter.native="search" @clear="clearSearch('phone')"
                            placeholder="请输入手机号">
                        </el-input>
                    </div>
                </div>
                <button class="global-button-style" @click="search()">
                    {{ $t("commonMsg.search") }}
                </button>
            </div>
            <div class="right-part">
                <button class="global-button-style" @click="handleAdd">
                    <img src="@/assets/img/cmb_btn_add.png" />新增
                </button>
            </div>
        </div>
        <el-card class="app-table-container" :body-style="{ padding: '20px' }">
            <div slot="header" class="user-table-header">
                <p>总数：{{ total ? total : 0 }}</p>
            </div>
            <div class="global-body-wrap" v-loading="loading">
                <AppTable :tableProps="tableProps" :tableData="tableData" @tableHandle="tableHandle" />
            </div>
            <Pagination :pageSize="paramsList.pageSize" :total="total" @pageNum="pageNum" @pageSize="pageSize"
                :pageSizes="true" />
        </el-card>

        <!-- 新增/编辑弹窗 -->
        <el-dialog :title="editId ? '编辑短信白名单' : '新增短信白名单'" :visible.sync="dialogVisible" width="500px"
            @close="handleDialogClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px">
                <el-form-item label="区号" prop="areaCode">
                    <el-input v-model="ruleForm.areaCode" placeholder="请输入区号（如：+86）"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="ruleForm.phone" placeholder="本地号码，不含区号（4-15 位数字）" maxlength="20">
                    </el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="ruleForm.remark" placeholder="请输入备注" :rows="4"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">确定</el-button>
            </div>
        </el-dialog>

        <opt-record-dialog ref="optRecordDialog" :fetchApi="fetchOptLogsApi" />
    </div>
</template>

<script>
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import OptRecordDialog from "@/components/OptRecordDialog/index.vue";

export default {
    name: "SmsWhitelist",
    components: {
        AppTable,
        Pagination,
        OptRecordDialog,
    },
    computed: {
        tableProps() {
            let tableProps = [
                {
                    prop: "areaCode",
                    label: "区号",
                },
                {
                    prop: "phone",
                    label: "手机号",
                },
                {
                    prop: "remark",
                    label: "备注",
                },
                {
                    prop: "createdAt",
                    label: "创建时间",
                },
                {
                    prop: "updatedAt",
                    label: "更新时间",
                },
                {
                    prop: "handle",
                    label: this.$t("org.manage"),
                    width: 220,
                    btn: [
                        this.$t("commonMsg.edit"),
                        this.$t("commonMsg.del"),
                        "操作详情",
                    ],
                },
            ];
            return tableProps;
        },
    },
    data() {
        // 本地号码（区号单独填；各国一般为 4～15 位数字）
        const validatePhone = (rule, value, callback) => {
            const v = value != null ? String(value).trim() : "";
            if (!v) {
                callback(new Error("请输入手机号"));
            } else if (!/^\d{4,15}$/.test(v)) {
                callback(
                    new Error("请输入 4-15 位数字本地号码（不含区号、勿含空格或符号）")
                );
            } else {
                callback();
            }
        };

        // 区号验证
        const validateAreaCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入区号"));
            } else if (!/^\+\d+$/.test(value)) {
                callback(new Error("区号格式不正确，应以+开头，后跟数字（如：+86）"));
            } else {
                callback();
            }
        };

        return {
            tableData: [],
            total: 0,
            phone: "",
            areaCode: "",
            paramsList: { page: 1, pageSize: 20 },
            loading: false,
            dialogVisible: false,
            editId: null,
            ruleForm: {
                areaCode: "",
                phone: "",
                remark: "",
            },
            rules: {
                areaCode: [
                    { required: true, validator: validateAreaCode, trigger: "blur" },
                ],
                phone: [
                    { required: true, validator: validatePhone, trigger: "blur" },
                ],
                remark: [],
            },
        };
    },
    methods: {
        async getSmsWhitelist() {
            this.loading = true;
            try {
                const res = await this.$http.getSmsWhitelist(this.paramsList);
                this.total = res.data.count || 0;
                this.tableData = res.data.items || [];
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.$message({
                    type: "error",
                    message: (error.response && error.response.data && error.response.data.message) || "获取列表失败",
                });
            }
        },

        search() {
            this.paramsList.page = 1;
            if (this.phone) {
                this.paramsList.phone = this.phone;
            } else {
                delete this.paramsList.phone;
            }
            if (this.areaCode) {
                this.paramsList.areaCode = this.areaCode;
            } else {
                delete this.paramsList.areaCode;
            }
            this.getSmsWhitelist();
        },

        clearSearch(type) {
            if (type === "phone") {
                this.phone = "";
                delete this.paramsList.phone;
            } else if (type === "areaCode") {
                this.areaCode = "";
                delete this.paramsList.areaCode;
            }
            this.paramsList.page = 1;
            this.getSmsWhitelist();
        },

        handleAdd() {
            this.editId = null;
            this.resetForm();
            this.dialogVisible = true;
        },

        async tableHandle(obj) {
            const row = obj.data && obj.data.row ? obj.data.row : obj.row;
            const id = row.id || row._id;

            if (!id) {
                this.$message({
                    type: "error",
                    message: "无法获取记录ID",
                });
                return;
            }

            if (obj.type === this.$t("commonMsg.edit")) {
                this.editId = id;
                await this.getSmsWhitelistDetail(id);
                this.dialogVisible = true;
            } else if (obj.type === this.$t("commonMsg.del")) {
                this.deleteSmsWhitelist(id);
            } else if (obj.type === "操作详情") {
                this.handleShowOptLogs(id);
            }
        },

        handleShowOptLogs(id) {
            this.$refs.optRecordDialog.open(id);
        },

        fetchOptLogsApi(id, params) {
            return this.$http.getSmsWhitelistOptLogs(id, params);
        },

        async getSmsWhitelistDetail(id) {
            if (!id) {
                this.$message({
                    type: "error",
                    message: "记录ID不能为空",
                });
                return;
            }
            try {
                const res = await this.$http.getSmsWhitelistDetail(id);
                this.ruleForm = {
                    areaCode: res.data.areaCode || "",
                    phone: res.data.phone || "",
                    remark: res.data.remark || "",
                };
            } catch (error) {
                this.$message({
                    type: "error",
                    message: (error.response && error.response.data && error.response.data.message) || "获取详情失败",
                });
            }
        },

        async deleteSmsWhitelist(id) {
            try {
                await this.$http.deleteSmsWhitelist(id);
                this.$message({
                    type: "success",
                    message: this.$t("alertMsg.delSuccess"),
                });
                this.getSmsWhitelist();
            } catch (error) {
                this.$message({
                    type: "error",
                    message: (error.response && error.response.data && error.response.data.message) || "删除失败",
                });
            }
        },

        resetForm() {
            this.ruleForm = {
                areaCode: "",
                phone: "",
                remark: "",
            };
            if (this.$refs.ruleForm) {
                this.$refs.ruleForm.clearValidate();
            }
        },

        handleDialogClose() {
            this.resetForm();
            this.editId = null;
        },

        submitForm() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    try {
                        if (this.editId) {
                            // 更新
                            await this.$http.updateSmsWhitelist(this.editId, this.ruleForm);
                            this.$message({
                                type: "success",
                                message: this.$t("alertMsg.editSuccess"),
                            });
                        } else {
                            // 新增
                            await this.$http.createSmsWhitelist(this.ruleForm);
                            this.$message({
                                type: "success",
                                message: this.$t("alertMsg.addSuccess"),
                            });
                        }
                        this.dialogVisible = false;
                        this.getSmsWhitelist();
                    } catch (error) {
                        this.$message({
                            type: "error",
                            message:
                                (error.response && error.response.data && error.response.data.message) ||
                                (this.editId ? "更新失败" : "创建失败"),
                        });
                    }
                } else {
                    return false;
                }
            });
        },

        pageNum(val) {
            this.paramsList.page = val;
            this.getSmsWhitelist();
        },

        pageSize(size) {
            this.paramsList.pageSize = size;
            this.paramsList.page = 1;
            this.getSmsWhitelist();
        },
    },

    mounted() {
        this.getSmsWhitelist();
    },
};
</script>

<style lang="scss" scoped>
.global-header-wrap {
    padding: 10px 44px;
}

.global-button-style {
    margin-top: 20px;
    margin-left: 0;
}

.sms-whitelist-page {
    height: 100%;
    display: flex;
    flex-direction: column;

    .user-header-left {
        width: calc(100% - 120px);
        float: left;
    }

    .left-part {
        float: left;
        margin-right: 20px;

        .listSearch {
            .el-input {
                width: 150px;

                .search-icon {
                    font-size: 22px;
                    cursor: pointer;
                }
            }
        }

        >span {
            margin-right: 10px;
            font-size: 14px;
        }

        .global-button-style {
            margin: 0;
        }
    }
}

.user-table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    >.global-button-style {
        margin-top: 0;
    }
}
</style>
